import React, { useState } from "react";
import WorkflowProfileFollowUp from "../dashboard/WorkflowProfileFollowUp";
import ProfileContactLogFollowUps from "./ProfileContactLogFollowUps";
import ProfileContactLogMeeting from "./ProfileContactLogMeeting";
import ProfileContactLogChatLogs from "./ProfileContactLogChatLogs";

const WorkflowProfileContactLogTab = () => {
  const [profileContactLogTab, setProfileContactLogTab] = useState(
    "ContactLogFollowUps"
  );
  return (
    <>
      <div className=" overflow-x-auto  w-[320px]  xs:w-[375px] md:w-full pt-4 px-6">
        <div className="flex gap-4 pt-2 mb-[30px]">
          <button
            onClick={() => setProfileContactLogTab("ContactLogFollowUps")}
            className={`text-black text-[14px] 3xl:text-[16px] font-medium py-[10px] px-4 whitespace-nowrap border border-solid border-[rgba(111,_106,_248,_0.30)] rounded-md duration-200 hover:bg-[linear-gradient(180deg,_#CAAEFA_0%,_#9153F4_100%)] hover:text-white hover:!border-transparent  ${
              profileContactLogTab === "ContactLogFollowUps"
                ? " text-white border-transparent bg-[linear-gradient(180deg,_#CAAEFA_0%,_#9153F4_100%)]"
                : ""
            } `}>
            Follow Ups
          </button>
          <button
            onClick={() => setProfileContactLogTab("ContactLogMeeting")}
            className={`text-black text-[14px] 3xl:text-[16px] font-medium py-[10px] px-4 whitespace-nowrap border border-solid border-[rgba(111,_106,_248,_0.30)] rounded-md duration-200 hover:bg-new_bule hover:text-white hover:!border-transparent ${
              profileContactLogTab === "ContactLogMeeting"
                ? " text-white border-transparent bg-new_bule"
                : ""
            }`}>
            Meeting
          </button>
          <button
            onClick={() => setProfileContactLogTab("ContactLogChatLogs")}
            className={`text-black text-[14px] 3xl:text-[16px] font-medium py-[10px] px-4 whitespace-nowrap border border-solid border-[rgba(111,_106,_248,_0.30)] rounded-md duration-200 hover:bg-[linear-gradient(153deg,_#1CFF70_-9.36%,_#50C6FF_98.49%);] hover:text-white hover:!border-transparent ${
              profileContactLogTab === "ContactLogChatLogs"
                ? " text-white border-transparent bg-[linear-gradient(153deg,_#1CFF70_-9.36%,_#50C6FF_98.49%);]"
                : ""
            }`}>
            Chat Logs
          </button>
        </div>
        <div className="h-[370px] md:h-[350px] xl:h-[480px] 3xl:h-[750px] overflow-y-auto  productivity_scrollbar_line  w-[320px] md:w-auto overflow-x-auto overflow_x_scroll_style ">
          {profileContactLogTab === "ContactLogFollowUps" && (
            <ProfileContactLogFollowUps />
          )}
          {profileContactLogTab === "ContactLogMeeting" && (
            <ProfileContactLogMeeting />
          )}
          {profileContactLogTab === "ContactLogChatLogs" && (
            <ProfileContactLogChatLogs />
          )}
        </div>
      </div>
    </>
  );
};

export default WorkflowProfileContactLogTab;
